const createRoute = ({ url, isActionBar = false, isNavMenu = false, isWellView = false }) => ({
  url,
  isActionBar,
  isNavMenu,
  isWellView,
})

export const ROUTES = {
  // ============================================================
  // Public Routes
  // ============================================================

  home: createRoute({
    url: '/',
    isNavMenu: true,
  }),

  pelotonLanding: createRoute({
    url: '/pelotonlanding',
  }),

  wellView: createRoute({
    url: '/well-view',
  }),

  loginCallback: createRoute({
    url: '/login/callback',
  }),

  resetPassword: createRoute({
    url: '/reset-password',
  }),

  // ============================================================
  // Main / Private Routes
  // ============================================================

  wellList: createRoute({
    url: '/well-list',
    isActionBar: true,
    isNavMenu: true,
  }),

  multiDbWellList: createRoute({
    url: '/well-list-multi-db',
  }),

  acDashboard: createRoute({
    url: '/anti-collision-dashboard',
    isActionBar: true,
    isWellView: true,
  }),

  dataQc: createRoute({
    url: '/data-qc',
    isActionBar: true,
    isNavMenu: true,
  }),

  assetSearch: createRoute({
    url: '/assetSearch',
  }),

  incidentDashboard: createRoute({
    url: '/incidentDashboard',
  }),

  analytics: createRoute({
    url: '/analytics/analyticsPage',
  }),

  wellInsights: createRoute({
    url: '/well-insights',
  }),

  logistics: createRoute({
    url: '/logistics',
  }),

  errorModels: createRoute({
    url: '/errorModels',
  }),

  witsmlServers: createRoute({
    url: '/witsmlServers',
  }),

  witsTemplates: createRoute({
    url: '/witsTemplates',
  }),

  dataAckFileHistory: createRoute({
    url: '/dataAckFileHistory',
  }),

  databaseTree: createRoute({
    url: '/databaseTree',
  }),

  dataMigration: createRoute({
    url: '/dataMigration',
  }),

  wellPlanning: createRoute({
    url: '/well-planning',
  }),

  // ============================================================
  // Well Pages
  // ============================================================

  wellDetails: createRoute({
    url: '/well-pages/well-page',
    isWellView: true,
  }),

  edr: createRoute({
    url: '/edr',
    isWellView: true,
  }),

  antiCollision: createRoute({
    url: '/well-pages/anticollision',
    isWellView: true,
  }),

  dailyReport: createRoute({
    url: '/well-pages/daily-report',
    isWellView: true,
  }),

  inventory: createRoute({
    url: '/well-pages/inventory',
    isWellView: true,
  }),

  surveys: createRoute({
    url: '/well-pages/surveys',
    isWellView: true,
  }),

  dailyCost: createRoute({
    url: '/well-pages/costs/dailyCostHeaders',
    isWellView: true,
  }),

  drillString: createRoute({
    url: '/well-pages/drill-string',
    isWellView: true,
  }),

  shippingTickets: createRoute({
    url: '/well-pages/tickets',
    isWellView: true,
  }),

  pipeTallys: createRoute({
    url: '/well-pages/pipeTallys',
    isWellView: true,
  }),

  engineering: createRoute({
    url: '/well-pages/engineering',
    isWellView: true,
  }),

  parametersRoadmap: createRoute({
    url: '/well-pages/parameterRoadmap',
    isWellView: true,
  }),

  connectionAnalysis: createRoute({
    url: '/well-pages/connectionAnalysis',
    isWellView: true,
  }),

  wallplotComposer: createRoute({
    url: '/well-pages/wallplotComposer',
    isWellView: true,
  }),

  // ============================================================
  // Admin
  // ============================================================

  bids: createRoute({
    url: '/admin/bids',
  }),

  rigNames: createRoute({
    url: '/admin/rigNames',
  }),

  adminDataQc: createRoute({
    url: '/admin/dataQc',
  }),

  objectQc: createRoute({
    url: '/admin/objectQc',
  }),

  invoiceQc: createRoute({
    url: '/admin/invoiceQc',
  }),

  shippingAddresses: createRoute({
    url: '/admin/shippingAddresses',
  }),

  crs: createRoute({
    url: '/admin/crs',
  }),

  personnelNames: createRoute({
    url: '/admin/personnelNames',
  }),

  personnelUtilization: createRoute({
    url: '/admin/personnelUtilization',
  }),

  auditData: createRoute({
    url: '/admin/auditData',
  }),

  integrations: createRoute({
    url: '/admin/integrations',
  }),

  componentCatalog: createRoute({
    url: '/admin/compCatalog',
  }),

  centralizerCatalog: createRoute({
    url: '/admin/centralizerCatalog',
  }),

  stopCollarCatalog: createRoute({
    url: '/admin/stopCollarCatalog',
  }),

  mwdProbeCatalog: createRoute({
    url: '/admin/mwdProbeCatalog',
  }),

  bulkEdit: createRoute({
    url: '/admin/bulkEdit',
  }),

  fileManager: createRoute({
    url: '/admin/fileManager',
  }),

  databaseChanges: createRoute({
    url: '/admin/databaseChanges',
  }),

  wallplotTemplates: createRoute({
    url: '/admin/wpcTemplates',
  }),

  // ============================================================
  // User Admin
  // ============================================================

  units: createRoute({
    url: '/admin/userAdmin/units',
  }),

  users: createRoute({
    url: '/admin/userAdmin/users',
  }),

  userRoles: createRoute({
    url: '/admin/userAdmin/roles',
  }),

  userDatabaseAccess: createRoute({
    url: '/admin/userAdmin/databaseAccess',
  }),

  // ============================================================
  // Innova Admin
  // ============================================================

  endpointUsage: createRoute({
    url: '/admin/innovaAdmin/endPointUsage',
  }),

  organizations: createRoute({
    url: '/admin/innovaAdmin/orgs',
  }),

  infrastructureDashboard: createRoute({
    url: '/admin/innovaAdmin/dashboard',
  }),

  adminAcDashboardStatus: createRoute({
    url: '/admin/innovaAdmin/acDashboard',
  }),

  icdsAdmin: createRoute({
    url: '/admin/innovaAdmin/icds',
  }),

  apiHealth: createRoute({
    url: '/admin/innovaAdmin/apiHealth',
  }),

  innovaVendors: createRoute({
    url: '/admin/innovaAdmin/innovaVendors',
  }),

  websiteFileUploads: createRoute({
    url: '/admin/innovaAdmin/adminWebsiteUploads',
  }),

  apiConfig: createRoute({
    url: '/admin/innovaAdmin/apiConfig',
  }),

  databaseRestoreStatus: createRoute({
    url: '/innovaAdmin/databaseRestoreStatus',
  }),

  databaseBackupFiles: createRoute({
    url: '/innovaAdmin/databaseBackupFiles',
  }),

  innovaAdminUsers: createRoute({
    url: '/innovaAdmin/innovaAdminUsers',
  }),

  // ============================================================
  // Licensing
  // ============================================================

  licenseDeactivations: createRoute({
    url: '/innovaAdmin/licensing/licenseDeactivations',
  }),

  licenses: createRoute({
    url: '/innovaAdmin/licensing/licenses',
  }),

  licenseRequest: createRoute({
    url: '/innovaAdmin/licensing/licenseRequest',
  }),

  // ============================================================
  // Innova Billing
  // ============================================================

  innovaCompanys: createRoute({
    url: '/innovaAdmin/innovaBilling/companys',
  }),

  innovaContacts: createRoute({
    url: '/innovaAdmin/innovaBilling/contacts',
  }),

  innovaSoftwareDetails: createRoute({
    url: '/innovaAdmin/innovaBilling/softwareDetails',
  }),

  innovaSoftwareBilling: createRoute({
    url: '/innovaAdmin/innovaBilling/softwareBilling',
  }),

  innovaInvoices: createRoute({
    url: '/innovaAdmin/innovaBilling/invoices',
  }),

  innovaQuotes: createRoute({
    url: '/innovaAdmin/innovaBilling/quotes',
  }),

  // ============================================================
  // WellSeeker Admin
  // ============================================================

  wellSeekerAdmin: createRoute({
    url: '/admin/wellSeekerAdmin',
  }),

  wellSeekerUpdateFiles: createRoute({
    url: '/admin/wellSeekerUpdateFiles',
  }),

  wellSeekerMagneticModelsUpload: createRoute({
    url: '/admin/wellSeekerMagneticModelsUpload',
  }),

  wellSeekerReportTemplatesUpload: createRoute({
    url: '/admin/wellSeekerReportTemplatesUpload',
  }),

  wellSeekerUnitSetsUpload: createRoute({
    url: '/admin/wellSeekerUnitSetsUpload',
  }),

  wellSeekerLicenseUploads: createRoute({
    url: '/admin/wellSeekerLicenseUploads',
  }),

  wellSeekerReportCoversUpload: createRoute({
    url: '/admin/wellSeekerReportCoversUpload',
  }),

  wellSeekerUpdateConfig: createRoute({
    url: '/admin/wellSeekerUpdateConfig',
  }),

  wellSeekerFeatureUsage: createRoute({
    url: '/admin/wellSeekerFeatureUsage',
  }),

  // ============================================================
  // Bank Reconciliation
  // ============================================================

  bankAccounts: createRoute({
    url: '/admin/bankRec/accounts',
  }),

  employees: createRoute({
    url: '/admin/bankRec/employees',
  }),
}
